<template>
  <span
    :class="[classNames]"
    v-html="icons.find(icon => icon.type === type).svg"
  ></span>
</template>
<script>
import icons from "@/components/svg";
export default {
  props: ["type", "classNames"],
  data() {
    return {
      icons
    };
  }
};
</script>
<style>
.left {
  margin-right: 5px;
}
.right {
  margin-left: 5px;
}
</style>
